import {
  ChangeDetectionStrategy,
  Component,
  input,
  OnInit,
  output,
  inject,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  MODAL_CONFIG,
  passwordMatchValidator,
  passwordValidator,
  VALIDATORS_CONSTANT,
} from '@core-utils';
import { FormLabelComponent, FormPasswordComponent } from '../../form';
import { TranslocoDirective } from '@jsverse/transloco';
import { CommonChangePasswordInterface } from '../../types';
import { uiKitScope } from '../../constants/ui-constant';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmModalComponent } from '../../modals';
import { ButtonComponent } from '../button/button.component';
import { provideUiKitScope } from '../../providers';

@Component({
  selector: 'ui-common-change-password',
  imports: [
    FormLabelComponent,
    FormPasswordComponent,
    ReactiveFormsModule,
    TranslocoDirective,
    ButtonComponent,
  ],
  templateUrl: './common-change-password.component.html',
  styleUrl: './common-change-password.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideUiKitScope()],
})
export class CommonChangePasswordComponent implements OnInit {
  private modalService = inject(NgbModal);

  protected readonly uiKitScope = uiKitScope;

  modalConfirmTitle = input<string>('');
  modalConfirmDescription = input<string>('');
  isLoading = input<boolean>(false);
  changePassword = output<CommonChangePasswordInterface>();

  form: FormGroup = new FormGroup({});

  ngOnInit() {
    this.initializeForm();
  }

  submit() {
    if (this.form.invalid) return;
    const modalRef = this.modalService.open(
      ConfirmModalComponent,
      MODAL_CONFIG,
    );
    modalRef.componentInstance.title.set(this.modalConfirmTitle());
    modalRef.componentInstance.description.set(this.modalConfirmDescription());
    modalRef.componentInstance.action.set('confirm');
    modalRef.result.then((result) => {
      if (result) {
        this.changePassword.emit(this.form.value);
      }
    });
  }

  private initializeForm() {
    this.form = new FormGroup(
      {
        oldPassword: new FormControl('', [Validators.required]),
        password: new FormControl('', [
          Validators.required,
          Validators.minLength(VALIDATORS_CONSTANT.PASSWORD_MIN_LENGTH),
          passwordValidator(),
        ]),
        confirmPassword: new FormControl('', [
          Validators.required,
          Validators.minLength(VALIDATORS_CONSTANT.PASSWORD_MIN_LENGTH),
          passwordValidator(),
        ]),
      },
      { validators: passwordMatchValidator },
    );
  }
}
